'use client';
import React from 'react';
import AccessorySlider from './_AccessorySlider';
import AccessoryGrid from './_AccessoryGrid';
import AccessoryScroll from './_AccessoryScroll';
import { MediaType } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { useIsMobile } from '@repo/ui/src/utils/useMediaQuery';
import { classNames } from '@repo/ui/src/utils/classNames';
import { appConfig } from '../../utils/appConfig';

interface CustomizeProps {
  headerTout: ToutContentProps;
  video: MediaType;
  showVideo: boolean;
  order: number;
  _testID?: string;
  background: string;
  reverse?: boolean;
  accessories: Array<{
    toutContent: ToutContentProps;
    img: {
      image: MediaType;
      altTag: string;
    };
    video?: MediaType;
  }>;
}

const CustomizeAccessories = ({
  headerTout,
  video,
  accessories,
  order,
  _testID,
  background,
  reverse,
}: CustomizeProps) => {
  const smAndDown = useIsMobile();
  const darkGray = background === 'Dark Gray';

  return (
    <section
      className="relative overflow-hidden"
      style={{ zIndex: order || 'initial' }}
      data-test-id={`customize_accessories_${_testID}`}
    >
      {video && (
        <AccessoryScroll
          headingLight={headerTout.headingLight}
          heading={headerTout.heading}
          align="left"
          description={headerTout.description}
          video={video as MediaType}
        />
      )}
      <div className={classNames('py-20', darkGray ? 'bg-neutral-700' : 'bg-neutral-800')}>
        {!video && (
          <div className="max-w-[1680px] mx-auto">
            <div className="relative flex items-end px-6 pb-8 md:px-12 md:pb-12">
              <ToutContent
                headingLight={headerTout.headingLight}
                heading={headerTout.heading}
                align="left"
                headingStyleVariant={appConfig.isTraeger ? 'h1' : 'h2'}
                divider={appConfig.isTraeger}
                fullWidth={appConfig.isMeater}
                dark
                description={headerTout.description}
                className={
                  appConfig.isMeater &&
                  "[&_h2]:w-fit [&_h2]:uppercase [&_h2]:after:content-[''] [&_h2]:after:block [&_h2]:after:w-full [&_h2]:after:h-1 [&_h2]:after:bg-brand-300 [&_h2]:after:mt-6 [&_h2]:after:mx-auto"
                }
              />
            </div>
          </div>
        )}
        {smAndDown && !appConfig.isMeater ? (
          <AccessorySlider accessories={accessories} />
        ) : (
          <AccessoryGrid accessories={accessories} reverse={reverse} />
        )}
      </div>
    </section>
  );
};

export default CustomizeAccessories;
